import React from "react";
import AppButton from "@common/components/app-button";
import {XMarkIcon} from "@heroicons/react/20/solid";
import {useArticleForm} from "../hooks/use-article-form.hook";
import YouTubeThumbnail from "@common/components/youtube-thumbnail";

interface SelectedExercisePillProps {
    id: string;
    title: string;
    url?: string;
}

const SelectedExercisePill: React.FC<SelectedExercisePillProps> = ({id, title, url}) => {
    const {form} = useArticleForm();

    const handleRemove = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        const selected = form.getValues("exercises") ?? [];
        form.setValue(
            "exercises",
            selected.filter((e: any) => e.id !== id),
            {shouldDirty: true, shouldValidate: true}
        );
    };

    const handleOpenLink = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        if (url) {
            window.open(url, "_blank", "noopener,noreferrer");
        }
    };

    return (
        <div className="mr-2 mb-2 inline-block h-[32px]">
            <AppButton
                className="cursor-auto !w-fit h-[32px] !p-0 !pl-1 bg-surface-level-1 hover:bg-on-surface/5 border border-outline rounded-lg text-sm font-semibold"
            >
                <div className="flex items-center gap-1 h-[32px] max-h-[32px]">
                    <YouTubeThumbnail url={url} onOpen={handleOpenLink} className="w-9 h-6 !rounded"/>
                    <span className="px-1 truncate">{title}</span>
                    <div
                        onClick={handleRemove}
                        className="w-fit h-fit cursor-pointer hover:bg-on-surface/10 rounded-2xl p-1">
                        <XMarkIcon className="w-5 h-5 min-w-5"/>
                    </div>
                </div>
            </AppButton>
        </div>
    );
};

export default SelectedExercisePill;

